@if (!isLoading()) {
  <div id="account-management"
       class="card shadow border-0 mb-3 tab-pane fade fade-in-zoom active show" role="tabpanel">
    <div class="card-header fw-bold bg-tertiary p-3 border-0">
      <h2 class="fs-6 fw-bold mb-0"><i class="bi bi-person-vcard me-2 text-primary"></i>Account management</h2>
    </div>
    @if (partner) {
      <div class="card-body">
        <div class="row">
          <div class="col-6 border-end">
            <form [formGroup]="form" (ngSubmit)="onSubmitAll()">
              <div
                class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mb-2">
                <h3 class="fw-bold fs-6 mb-0">Account informations</h3>
                <i class="bi bi-person-bounding-box text-primary me-2"></i>
              </div>
              <div class="row g-3">
                <div class="col-6">
                  <label class="form-label">Company status</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-person-check"></i></span>
                    <select class="form-select" formControlName="companyStatus">
                      @for (companyStatus of companyStatusList; track companyStatus) {
                        <option
                          [value]="companyStatus">{{ 'companyStatus.' + companyStatus | translate }}
                        </option>
                      }
                    </select>
                  </div>
                </div>
                <div class="col-6">
                  <label class="form-label">Account Status</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-people"></i></span>
                    <select class="form-select" formControlName="status">
                      @for (partnerStatus of partnerStatusList; track partnerStatus) {
                        <option
                          [value]="partnerStatus">{{ 'partnerStatus.' + partnerStatus | translate }}
                        </option>
                      }
                    </select>
                  </div>
                </div>
                <div class="col-12">
                  <label class="form-label">Language</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-translate"></i></span>
                    <app-dropdown-select [multiple]="true" formControlName="langs" placeholder="French, English...">
                      @for (lang of languages; track lang) {
                        <app-dropdown-select-option [value]="lang.isoCode">
                          <img [ngSrc]="langService.getLanguageFlag(lang)" [alt]="lang.name" width="24" height="24"
                               class="me-1 country-flag">{{ lang.name }}
                        </app-dropdown-select-option>
                      }
                    </app-dropdown-select>
                  </div>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col">
                      <label for="partner-picture" class="form-label">Partner Picture</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-image"></i></span>
                        <input type="file" id="partner-picture" class="form-control"
                               (change)="documentUpload($event, 'image')">
                      </div>
                    </div>
                    @if (partner.image) {
                      <div class="col-auto">
                        <div class="profile-picture">
                          <img [ngSrc]="imageService.getImageUrl(partner.image, 62, 62)" alt="Partner profile picture"
                               fill>
                        </div>
                      </div>
                    }
                  </div>
                </div>
                <div class="col-12">
                  <label class="form-label">Company Name</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-building"></i></span>
                    <input type="text" class="form-control" placeholder="Company name" formControlName="companyName">
                  </div>
                </div>
                <div class="col-6">
                  <label class="form-label small fw-bold">Company registration number</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-card-checklist"></i></span>
                    <input type="text" class="form-control" formControlName="companyRegistrationNumber">
                  </div>
                </div>
                <div class="col">
                  <label class="form-label small fw-bold">Company VAT number</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-file-earmark-text"></i></span>
                    <input type="text" class="form-control" formControlName="companyVatNumber">
                  </div>
                </div>
                <div class="col-auto">
                  <label class="form-label small fw-bold">Subject to VAT</label>
                  <app-input-switch formControlName="subjectToVat"></app-input-switch>
                </div>
                <div class="col-12">
                  <label class="form-label small fw-bold">Address</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-house"></i></span>
                    <textarea class="form-control" formControlName="address"></textarea>
                  </div>
                </div>
                <div class="col-6">
                  <label class="form-label small fw-bold">Zip code</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-mailbox"></i></span>
                    <input type="text" class="form-control" formControlName="zipCode">
                  </div>
                </div>
                <div class="col-6">
                  <label class="form-label small fw-bold">City</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-geo-alt"></i></span>
                    <input type="text" class="form-control" formControlName="city">
                  </div>
                </div>
                <div class="col-6">
                  <label class="form-label small fw-bold">State</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-map"></i></span>
                    <input type="text" class="form-control" formControlName="state">
                  </div>
                </div>
                <div class="col-6">
                  <label class="form-label">Country</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-globe"></i></span>
                    <select class="form-select" formControlName="country">
                      @for (country of countries; track country) {
                        <option [ngValue]="country.isoCode">{{ country.name }}</option>
                      }
                    </select>
                  </div>
                </div>
                <div class="col-12">
                  <label class="form-label">Phone Number</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-telephone"></i></span>
                    <input type="tel" class="form-control" placeholder="Phone number" formControlName="phoneNumber">
                  </div>
                </div>
                <div class="col-12">
                  <label class="form-label">Email Address</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-envelope"></i></span>
                    <input type="email" class="form-control" placeholder="Email address" formControlName="email"
                           autocomplete="new-password">
                  </div>
                </div>
                <div class="col-12 text-end">
                  <button type="submit" class="btn btn-primary fw-bold">Update</button>
                </div>
              </div>
            </form>
            @if (partner.isAffiliate()) {
              <form [formGroup]="contacts[CompanyRole.SIGNATORY]"
                    (ngSubmit)="onSubmitAll()">
                <div
                  class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mt-3 mb-2">
                  <h3 class="fw-bold fs-6 mb-0">Account authorized signatory</h3>
                  <i class="bi bi-pencil-square text-primary me-2"></i>
                </div>
                <div class="row g-3">
                  <div class="col-4">
                    <label class="form-label small fw-bold">Civility</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-gender-ambiguous"></i></span>
                      <select class="form-select" formControlName="civility">
                        @for (civility of civilityList; track civility) {
                          <option
                            [value]="civility">{{ 'civility.' + civility | translate }}
                          </option>
                        }
                      </select>
                    </div>
                  </div>
                  <div class="col-4">
                    <label class="form-label small fw-bold">First Name</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-person"></i></span>
                      <input type="text" class="form-control" formControlName="firstname">
                    </div>
                  </div>
                  <div class="col-4">
                    <label class="form-label small fw-bold">Last Name</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-person"></i></span>
                      <input type="text" class="form-control" formControlName="lastname">
                    </div>
                  </div>
                  <div class="col-12">
                    <label class="form-label small fw-bold">Email address</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-envelope"></i></span>
                      <input type="email" class="form-control" formControlName="email" autocomplete="new-password">
                    </div>
                  </div>
                  <div class="col-12">
                    <label class="form-label small fw-bold">Mobile number</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-phone"></i></span>
                      <input type="text" class="form-control" formControlName="phoneNumber">
                    </div>
                  </div>
                  <div class="col-6">
                    <label class="form-label small fw-bold">Telegram</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-telegram"></i></span>
                      <input type="text" class="form-control" formControlName="telegram">
                    </div>
                  </div>
                  <div class="col-6">
                    <label class="form-label small fw-bold">Teams</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-microsoft-teams"></i></span>
                      <input type="text" class="form-control" formControlName="teams">
                    </div>
                  </div>
                  <div class="col-12">
                    <label class="form-label small fw-bold">Nickname</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-person-badge"></i></span>
                      <input type="text" class="form-control" formControlName="nickname">
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="row">
                      <div class="col">
                        <label class="form-label small fw-bold">Document</label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="bi bi-file-earmark"></i></span>
                          <input type="file" class="form-control"
                                 (change)="documentUpload($event, 'signatoryContactDocument')">
                        </div>
                      </div>
                      @if (partner.contacts[CompanyRole.SIGNATORY]?.document?.url) {
                        <div class="col-auto pt-4">
                          <a [href]="$safeNavigationMigration(partner.contacts[CompanyRole.SIGNATORY].document?.url)"
                             download>
                            <i class="bi bi-download h3"></i>
                          </a>
                        </div>
                      }
                    </div>
                  </div>
                  <div class="col-12 text-end">
                    <button type="submit" class="btn btn-primary fw-bold">Update</button>
                  </div>
                </div>
              </form>
            }
          </div>
          <div class="col-6">
            <form [formGroup]="contacts[CompanyRole.MAIN]" (ngSubmit)="onSubmitAll()">
              <div
                class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mb-2">
                <h3 class="fw-bold fs-6 mb-0">Main contact</h3>
                <i class="bi bi-person-lines-fill text-primary me-2"></i>
              </div>
              <div class="row g-3">
                <div class="col-4">
                  <label class="form-label">Civility</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-person"></i></span>
                    <select class="form-select" formControlName="civility">
                      @for (civility of civilityList; track civility) {
                        <option
                          [value]="civility">{{ 'civility.' + civility | translate }}
                        </option>
                      }
                    </select>
                  </div>
                </div>
                <div class="col-4">
                  <label class="form-label">First Name</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-person-fill"></i></span>
                    <input type="text" class="form-control" placeholder="First name" formControlName="firstname">
                  </div>
                </div>
                <div class="col-4">
                  <label class="form-label">Last Name</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-person-fill"></i></span>
                    <input type="text" class="form-control" placeholder="Last name" formControlName="lastname">
                  </div>
                </div>
                <div class="col-12">
                  <label class="form-label">Email Address</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-envelope"></i></span>
                    <input type="email" class="form-control" placeholder="Email address" formControlName="email"
                           autocomplete="new-password">
                  </div>
                </div>
                <div class="col-12">
                  <label class="form-label">Mobile Number</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-telephone"></i></span>
                    <input type="tel" class="form-control" placeholder="Phone number" formControlName="phoneNumber">
                  </div>
                </div>
                <div class="col-6">
                  <label class="form-label">Telegram</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-telegram"></i></span>
                    <input type="text" class="form-control" placeholder="Telegram username" formControlName="telegram">
                  </div>
                </div>
                <div class="col-6">
                  <label class="form-label">Teams</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-microsoft-teams"></i></span>
                    <input type="text" class="form-control" placeholder="Teams username" formControlName="teams">
                  </div>
                </div>
                <div class="col-12">
                  <label class="form-label small fw-bold">Nickname</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-person-badge"></i></span>
                    <input type="text" class="form-control" formControlName="nickname">
                  </div>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col">
                      <label class="form-label small fw-bold">Document</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-file-earmark"></i></span>
                        <input type="file" class="form-control"
                               (change)="documentUpload($event, 'mainContactDocument')">
                      </div>
                    </div>
                    @if (partner.contacts[CompanyRole.MAIN]?.document?.url) {
                      <div class="col-auto pt-4">
                        <a [href]="$safeNavigationMigration(partner.contacts[CompanyRole.MAIN].document?.url)" download>
                          <i class="bi bi-download h3"></i>
                        </a>
                      </div>
                    }
                  </div>
                </div>
                <div class="col-12 text-end">
                  <button type="submit" class="btn btn-primary fw-bold">Update</button>
                </div>
              </div>
            </form>
            <form [formGroup]="form" (ngSubmit)="onSubmitAll()">
              <div
                class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mt-3 mb-2">
                <h3 class="fw-bold fs-6 mb-0">Account configuration</h3>
                <i class="bi bi-person-gear text-primary me-2"></i>
              </div>
              <div class="row g-3">
                <div class="col-12">
                  <label class="form-label">Account Manager</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-people"></i></span>
                    <select class="form-select" formControlName="accountManagerId">
                      @for (user of accountManagers; track user) {
                        <option [value]="user.id">{{ user }}</option>
                      }
                    </select>
                  </div>
                </div>
                @if (partner.isMediaBuy()) {
                  <div class="col-12 opacity-50">
                    <label class="form-label small fw-bold">Credential API URL</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-globe"></i></span>
                      <input type="text" class="form-control" formControlName="credentialUrl" readonly>
                    </div>
                  </div>
                  <div class="col-12 opacity-50">
                    <label class="form-label small fw-bold">Credential Username</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-person"></i></span>
                      <input type="text" class="form-control" formControlName="credentialUsername" readonly>
                    </div>
                  </div>
                  <div class="col-12 opacity-50">
                    <label class="form-label small fw-bold">Credential Password</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-lock"></i></span>
                      <input type="text" class="form-control" formControlName="credentialPassword" readonly>
                    </div>
                  </div>
                }
                @if (partner.isAffiliate()) {
                  <div class="col-12">
                    <label class="form-label small fw-bold">Payment threshold</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-cash-stack"></i></span>
                      <input type="text" class="form-control" formControlName="paymentThreshold">
                    </div>
                  </div>
                  <div class="col-12">
                    <label class="form-label small fw-bold">Payment terms</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-file-earmark-text"></i></span>
                      <select class="form-select" formControlName="paymentTerms">
                        @for (paymentTerm of paymentTermList; track paymentTerm) {
                          <option
                            [value]="paymentTerm">{{ 'paymentTerm.' + paymentTerm | translate }}
                          </option>
                        }
                      </select>
                    </div>
                  </div>
                  <div class="col-12">
                    <label class="form-label small fw-bold">Payment currency</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-currency-exchange"></i></span>
                      <select class="form-select" formControlName="paymentCurrency">
                        <option value="EUR">EUR</option>
                        <option value="USD">USD</option>
                        <option value="GBP">GBP</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12">
                    <label class="form-label small fw-bold">Payment method</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-credit-card"></i></span>
                      <select class="form-select" formControlName="paymentMethod">
                        @for (paymentMethod of paymentMethodList; track paymentMethod) {
                          <option
                            [value]="paymentMethod">{{ 'paymentMethod.' + paymentMethod | translate }}
                          </option>
                        }
                      </select>
                    </div>
                  </div>
                }
                <div class="col-12 text-end">
                  <button type="submit" class="btn btn-primary fw-bold">Update</button>
                </div>
              </div>
            </form>
            @if (partner.isAffiliate()) {
              <form [formGroup]="form" (ngSubmit)="onSubmitAll()">
                <div
                  class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mt-3 mb-2">
                  <h3 class="fw-bold fs-6 mb-0">Payment informations</h3>
                  <i class="bi bi-wallet2 text-primary me-2"></i>
                </div>
                <div class="row g-3">
                  <div class="col-12">
                    <label class="form-label small fw-bold">Account holder</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-person"></i></span>
                      <input type="text" class="form-control" formControlName="accountHolder">
                    </div>
                  </div>
                  <div class="col-12">
                    <label class="form-label small fw-bold">Bank name</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-bank"></i></span>
                      <input type="text" class="form-control" formControlName="bankName">
                    </div>
                  </div>
                  <div class="col-12">
                    <label class="form-label small fw-bold">Bank address</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-geo-alt"></i></span>
                      <textarea class="form-control" formControlName="bankAddress"></textarea>
                    </div>
                  </div>
                  <div class="col-12">
                    <label class="form-label small fw-bold">IBAN / Account number</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-credit-card-2-front"></i></span>
                      <input type="text" class="form-control" formControlName="iban">
                    </div>
                  </div>
                  <div class="col-12">
                    <label class="form-label small fw-bold">SWIFT / BIC</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-file-earmark-text"></i></span>
                      <input type="text" class="form-control" formControlName="swift">
                    </div>
                  </div>
                  <div class="col-12">
                    <label class="form-label small fw-bold">Routing number / ABA</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-diagram-3"></i></span>
                      <input type="text" class="form-control" formControlName="routingNumber">
                    </div>
                  </div>
                  <div class="col-12 text-end">
                    <button type="submit" class="btn btn-primary fw-bold">Update</button>
                  </div>
                </div>
              </form>
            }
          </div>
          <div class="col-12">
            @if (partner.isAffiliate()) {
              <form [formGroup]="form" (ngSubmit)="onSubmitAll()">
                <div
                  class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mt-3 mb-2">
                  <h3 class="fw-bold fs-6 mb-0">Account Compliance</h3>
                  <i class="bi bi-upload text-primary me-2"></i>
                </div>
                <div class="row g-3">
                  @if (partner) {
                    <app-compliance-documents #compliance [model]="partner"></app-compliance-documents>
                  }
                  <div class="col-12">
                    <label class="form-label small fw-bold">Notes</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-journal-text"></i></span>
                      <textarea class="form-control" formControlName="accountComplianceNote"></textarea>
                    </div>
                  </div>
                  <div class="col-12 text-end">
                    <button type="submit" class="btn btn-primary fw-bold">Update</button>
                  </div>
                </div>
              </form>
            }
          </div>
          @if (partner.isAffiliate()) {
            @for (companyRole of companyRoles; track companyRole) {
              <form [formGroup]="contacts[companyRole]"
                    (ngSubmit)="onSubmitAll()">
                <div class="col-12">
                  <div
                    class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mt-3 mb-2">
                    <h3 class="fw-bold fs-6 mb-0"><span class="text-capitalize">{{ companyRole }}</span> contact</h3>
                    <i class="bi bi-upload text-primary me-2"></i>
                  </div>
                  <div class="row g-3">
                    <div class="col-3">
                      <label class="form-label small fw-bold">Civility</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-person"></i></span>
                        <select class="form-select" formControlName="civility">
                          @for (civility of civilityList; track civility) {
                            <option
                              [value]="civility">{{ 'civility.' + civility | translate }}
                            </option>
                          }
                        </select>
                      </div>
                    </div>
                    <div class="col-3">
                      <label class="form-label small fw-bold">First Name</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-person-fill"></i></span>
                        <input type="text" class="form-control" placeholder="Enter first name"
                               formControlName="firstname">
                      </div>
                    </div>
                    <div class="col-3">
                      <label class="form-label small fw-bold">Last Name</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-person-fill"></i></span>
                        <input type="text" class="form-control" placeholder="Enter last name"
                               formControlName="lastname">
                      </div>
                    </div>
                    <div class="col-3">
                      <label class="form-label small fw-bold">Nick Name</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-person-badge"></i></span>
                        <input type="text" class="form-control" placeholder="Enter nickname" formControlName="nickname">
                      </div>
                    </div>
                    <div class="col-3">
                      <label class="form-label small fw-bold">Email Address</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-envelope"></i></span>
                        <input type="email" class="form-control" placeholder="Enter email address"
                               formControlName="email"
                               autocomplete="new-password">
                      </div>
                    </div>
                    <div class="col-3">
                      <label class="form-label small fw-bold">Phone Number</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-telephone"></i></span>
                        <input type="tel" class="form-control" placeholder="Enter phone number"
                               formControlName="phoneNumber">
                      </div>
                    </div>
                    <div class="col-3">
                      <label class="form-label small fw-bold">Teams</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-microsoft-teams"></i></span>
                        <input type="text" class="form-control" placeholder="Enter Teams username"
                               formControlName="teams">
                      </div>
                    </div>
                    <div class="col-3">
                      <label class="form-label small fw-bold">Telegram</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-telegram"></i></span>
                        <input type="text" class="form-control" placeholder="Enter Telegram username"
                               formControlName="telegram">
                      </div>
                    </div>
                    <div class="col-12 text-end">
                      <button type="submit" class="btn btn-primary fw-bold">Update</button>
                    </div>
                  </div>
                </div>
              </form>
            }
            <form [formGroup]="form" (ngSubmit)="onSubmitAll()">
              <div class="col-12">
                <div
                  class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mt-3 mb-2">
                  <h3 class="fw-bold fs-6 mb-0">Additional informations </h3>
                  <i class="bi bi-upload text-primary me-2"></i>
                </div>
                <div class="row g-3">
                  <div class="col-3">
                    <label class="form-label">Prospect Origin</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-geo-alt"></i></span>
                      <select class="form-select" formControlName="prospectOrigin">
                        @for (prospectOrigin of prospectOriginList; track prospectOrigin) {
                          <option
                            [value]="prospectOrigin">{{ 'prospectOrigin.' + prospectOrigin | translate }}
                          </option>
                        }
                      </select>
                    </div>
                  </div>
                  <div class="col-3">
                    <label class="form-label small fw-bold">Typology</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-diagram-3"></i></span>
                      <select class="form-select" formControlName="typology">
                        @for (typology of typologyList; track typology) {
                          <option
                            [value]="typology">{{ 'typology.' + typology | translate }}
                          </option>
                        }
                      </select>
                    </div>
                  </div>
                  <div class="col-3">
                    <label class="form-label small fw-bold">Verticals</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-grid"></i></span>
                      <app-dropdown-select [multiple]="true" formControlName="verticals" placeholder="Verticals">
                        @for (vertical of verticalList; track vertical) {
                          <app-dropdown-select-option
                            [value]="vertical.id">{{ ('vertical.' + vertical.identifier) | translate }}
                          </app-dropdown-select-option>
                        }
                      </app-dropdown-select>
                    </div>
                  </div>
                  <div class="col-3">
                    <label class="form-label small fw-bold">Géos</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-globe"></i></span>
                      <app-dropdown-select [multiple]="true" formControlName="geographicAreas" placeholder="Geos">
                        @for (geographicArea of geographicAreaList; track geographicArea) {
                          <app-dropdown-select-option
                            [value]="geographicArea">{{ 'geographicArea.' + geographicArea | translate }}
                          </app-dropdown-select-option>
                        }
                      </app-dropdown-select>
                    </div>
                  </div>
                  <div class="col-3">
                    <label class="form-label small fw-bold">Traffic Sources</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-bar-chart"></i></span>
                      <app-dropdown-select [multiple]="true" formControlName="trafficSources"
                                           placeholder="Traffic Sources">
                        @for (trafficSource of trafficSourceList; track trafficSource) {
                          <app-dropdown-select-option
                            [value]="trafficSource">{{ 'trafficSource.' + trafficSource | translate }}
                          </app-dropdown-select-option>
                        }
                      </app-dropdown-select>
                    </div>
                  </div>
                  <div class="col-3">
                    <label class="form-label small fw-bold">Experience</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-person-badge"></i></span>
                      <select class="form-select" formControlName="experience">
                        @for (experience of experienceList; track experience) {
                          <option
                            [value]="experience">{{ 'experience.' + experience | translate }}
                          </option>
                        }
                      </select>
                    </div>
                  </div>
                  <div class="col-3">
                    <label class="form-label small fw-bold">Monthly Estimate Revenues</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-currency-dollar"></i></span>
                      <select class="form-select" formControlName="estimatedMonthlyRevenue">
                        @for (estimatedMonthlyRevenue of estimatedMonthlyRevenueList; track estimatedMonthlyRevenue) {
                          <option
                            [value]="estimatedMonthlyRevenue">{{ 'estimatedMonthlyRevenue.' + estimatedMonthlyRevenue | translate }}
                          </option>
                        }
                      </select>
                    </div>
                  </div>
                  <div class="col-3">
                    <label class="form-label small fw-bold">Website URL</label>
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-link-45deg"></i></span>
                      <input type="url" class="form-control" placeholder="Enter website URL"
                             formControlName="websiteUrl">
                    </div>
                  </div>
                  <div class="col-12 text-end">
                    <button type="submit" class="btn btn-primary fw-bold">Update</button>
                  </div>
                </div>
              </div>
            </form>
          }
          @if (partner.isMediaBuy() && advertisingPlatformInfoForm) {
            <form [formGroup]="advertisingPlatformInfoForm.getFormGroup()"
                  (ngSubmit)="onSubmitAll()">
              <div class="col-12">
                <div
                  class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mt-3 mb-2">
                  <h3 class="fw-bold fs-6 mb-0">{{ getAdvertisingPlatform().name }} Information</h3>
                  <i class="bi bi-upload text-primary me-2"></i>
                </div>
                <div class="row g-3">
                  @if (advertisingPlatformInfoForm.hasFormControl('currencyId')) {
                    <div class="col-3">
                      <label class="form-label small fw-bold">Currency</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-currency-exchange"></i></span>
                        <select id="currency" class="form-select" formControlName="currencyId">
                          @for (currency of currencies; track currency) {
                            <option [ngValue]="currency.id">{{ currency }}</option>
                          }
                        </select>
                      </div>
                    </div>
                  }
                  @if (advertisingPlatformInfoForm.hasFormControl('clientId')) {
                    <div class="col-3">
                      <label class="form-label small fw-bold">Client ID</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-person"></i></span>
                        <input type="text" class="form-control" formControlName="clientId"/>
                      </div>
                    </div>
                  }
                  @if (advertisingPlatformInfoForm.hasFormControl('clientSecret')) {
                    <div class="col-3">
                      <label class="form-label small fw-bold">Client Secret</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-incognito"></i></span>
                        <input type="text" class="form-control" formControlName="clientSecret"/>
                      </div>
                    </div>
                  }
                  @if (advertisingPlatformInfoForm.hasFormControl('customerId')) {
                    <div class="col-3">
                      <label class="form-label small fw-bold">Customer ID</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-person-vcard"></i></span>
                        <input type="text" class="form-control" formControlName="customerId"/>
                      </div>
                    </div>
                  }
                  @if (advertisingPlatformInfoForm.hasFormControl('accountId')) {
                    <div class="col-3">
                      <label class="form-label small fw-bold">Account ID</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-person-vcard"></i></span>
                        <input type="text" class="form-control" formControlName="accountId"/>
                      </div>
                    </div>
                  }
                  @if (advertisingPlatformInfoForm.hasFormControl('pixelId')) {
                    <div class="col-3">
                      <label class="form-label small fw-bold">Pixel ID</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-facebook"></i></span>
                        <input type="text" class="form-control" formControlName="pixelId"/>
                      </div>
                    </div>
                  }
                  @if (advertisingPlatformInfoForm.hasFormControl('pixelToken')) {
                    <div class="col-3">
                      <label class="form-label small fw-bold">Pixel Token</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-twitter-x"></i></span>
                        <input type="text" class="form-control" formControlName="pixelToken"/>
                      </div>
                    </div>
                  }
                  @if (advertisingPlatformInfoForm.hasFormControl('developerToken')) {
                    <div class="col-3">
                      <label class="form-label small fw-bold">Developer Token</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-code-square"></i></span>
                        <input type="text" class="form-control" formControlName="developerToken"/>
                      </div>
                    </div>
                  }
                  @if (advertisingPlatformInfoForm.hasFormControl('username')) {
                    <div class="col-3">
                      <label class="form-label small fw-bold">Username</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-person"></i></span>
                        <input type="text" class="form-control" formControlName="username"/>
                      </div>
                    </div>
                  }
                  @if (advertisingPlatformInfoForm.hasFormControl('password')) {
                    <div class="col-3">
                      <label class="form-label small fw-bold">Password</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-incognito"></i></span>
                        <input type="text" class="form-control" formControlName="password"/>
                      </div>
                    </div>
                  }
                  @if (advertisingPlatformInfoForm.hasFormControl('marketerId')) {
                    <div class="col-3">
                      <label class="form-label small fw-bold">Marketer ID</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-person-fill"></i></span>
                        <input type="text" class="form-control" formControlName="marketerId"/>
                      </div>
                    </div>
                  }
                  @if (advertisingPlatformInfoForm.hasFormControl('appId')) {
                    <div class="col-3">
                      <label class="form-label small fw-bold">App ID</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-app"></i></span>
                        <input type="text" class="form-control" formControlName="appId"/>
                      </div>
                    </div>
                  }
                  @if (advertisingPlatformInfoForm.hasFormControl('appSecret')) {
                    <div class="col-3">
                      <label class="form-label small fw-bold">App Secret</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-incognito"></i></span>
                        <input type="text" class="form-control" formControlName="appSecret"/>
                      </div>
                    </div>
                  }
                  @if (advertisingPlatformInfoForm.hasFormControl('accessToken')) {
                    <div class="col-3">
                      <label class="form-label small fw-bold">Access Token</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-code-square"></i></span>
                        <input type="text" class="form-control" formControlName="accessToken"/>
                      </div>
                    </div>
                  }
                </div>
                <div class="row">
                  <div class="col-12 text-end">
                    <button type="submit" class="btn btn-primary fw-bold">Update</button>
                  </div>
                </div>
                @if (isGoogleAds()) {
                  <app-google-ads-config-form
                    [partnerAdvertisingPlatform]="getPartnerAdvertisingPlatform()"></app-google-ads-config-form>
                }
                @if (isMetaAds()) {
                  <app-meta-ads-config-form
                    [partnerAdvertisingPlatform]="getPartnerAdvertisingPlatform()"></app-meta-ads-config-form>
                }
                @if (isMicrosoftAds()) {
                  <app-microsoft-ads-config-form
                    [partnerAdvertisingPlatform]="getPartnerAdvertisingPlatform()"></app-microsoft-ads-config-form>
                }
                @if (isXAds()) {
                  <app-x-ads-config-form
                    [partnerAdvertisingPlatform]="getPartnerAdvertisingPlatform()"></app-x-ads-config-form>
                }
              </div>
            </form>
          }
        </div>
      </div>
    }
  </div>
}
